import moment from 'moment'
import 'moment/locale/th'; // import Thai locale for moment.js
import dayjs from 'dayjs'

export const changeOnlyMonth = date => {
    let monthThai = [];
    monthThai['01'] = 'มกราคม';
    monthThai['02'] = 'กุมภาพันธ์';
    monthThai['03'] = 'มีนาคม';
    monthThai['04'] = 'เมษายน';
    monthThai['05'] = 'พฤษภาคม';
    monthThai['06'] = 'มิถุนายน';
    monthThai['07'] = 'กรกฎาคม';
    monthThai['08'] = 'สิงหาคม';
    monthThai['09'] = 'กันยายน';
    monthThai['10'] = 'ตุลาคม';
    monthThai['11'] = 'พฤศจิกายน';
    monthThai['12'] = 'ธันวาคม';

    const newdate = monthThai[dayjs(date).format('MM')]
    return newdate
}

export const changeFormatdate = date => {

    let monthThai = [];
    monthThai['01'] = 'มกราคม';
    monthThai['02'] = 'กุมภาพันธ์';
    monthThai['03'] = 'มีนาคม';
    monthThai['04'] = 'เมษายน';
    monthThai['05'] = 'พฤษภาคม';
    monthThai['06'] = 'มิถุนายน';
    monthThai['07'] = 'กรกฎาคม';
    monthThai['08'] = 'สิงหาคม';
    monthThai['09'] = 'กันยายน';
    monthThai['10'] = 'ตุลาคม';
    monthThai['11'] = 'พฤศจิกายน';
    monthThai['12'] = 'ธันวาคม';

    if (date) {
        const newdate = dayjs(date).format('D') + " " + monthThai[dayjs(date).format('MM')] + " " + (parseInt(dayjs(date).format('YYYY')) + 543).toString()
        return newdate
    }
}

export const changeFormatFullDateTime = date => {
    let monthThai = [];
    monthThai['01'] = 'มกราคม';
    monthThai['02'] = 'กุมภาพันธ์';
    monthThai['03'] = 'มีนาคม';
    monthThai['04'] = 'เมษายน';
    monthThai['05'] = 'พฤษภาคม';
    monthThai['06'] = 'มิถุนายน';
    monthThai['07'] = 'กรกฎาคม';
    monthThai['08'] = 'สิงหาคม';
    monthThai['09'] = 'กันยายน';
    monthThai['10'] = 'ตุลาคม';
    monthThai['11'] = 'พฤศจิกายน';
    monthThai['12'] = 'ธันวาคม';
    if (date) {
        // const convertDate = date.slice(0, 10);
        const newdate = dayjs(date).format('D') + " " + monthThai[dayjs(date).format('MM')] + " " + (parseInt(dayjs(date).format('YYYY')) + 543).toString() + " " + dayjs(date).format('HH:mm')
        return newdate
    }
}

export const changeYear = year => {
    return parseInt(year) + 543;
}

export const timeDate = date => {
    return dayjs(date).format('HH:mm')
}

export const dateTh = date => {
    return dayjs(date).format('DD') + "/" + dayjs(date).format('MM') + "/" + (parseInt(dayjs(date).format('YYYY')) + 543)
}

export const dateEng = date => {
    return dayjs(date).format('D/MM/yyyy')
}

export const dateEngTime = date => {
    return dayjs(date).format('D/MM/yyyy HH:mm')
}

export const checkMoreThanLess = (startDate, endDate) => {
    let checkDatemore = dayjs(startDate, "D/MM/YYYY").diff(dayjs(endDate, "D/MM/YYYY")).toString();

    if (!checkDatemore.includes("-")) {
        return dayjs(startDate)
    }
}

export const checkMoreMonthisAfter = (startDate, endDate) => {
    let checkDatemore = dayjs(startDate, "D/MM/YYYY").isAfter(dayjs(endDate, "D/MM/YYYY")) ? dayjs(startDate, "D/MM/YYYY").isAfter(dayjs(endDate, "D/MM/YYYY")) : false;

    // let disAllowCancle = leaveDocumentDetail ? dayjs(currentDate).isAfter(dayjs(leaveDocumentDetail.leaveStartDate).format('YYYY-MM-DD')) : false
    // if(!checkDatemore.includes("-")){
    //     return dayjs(startDate)
    // }

    return checkDatemore
}



export const changeFormatFulldate = date => {
    let monthThai = [];
    monthThai['01'] = 'มกราคม';
    monthThai['02'] = 'กุมภาพันธ์';
    monthThai['03'] = 'มีนาคม';
    monthThai['04'] = 'เมษายน';
    monthThai['05'] = 'พฤษภาคม';
    monthThai['06'] = 'มิถุนายน';
    monthThai['07'] = 'กรกฎาคม';
    monthThai['08'] = 'สิงหาคม';
    monthThai['09'] = 'กันยายน';
    monthThai['10'] = 'ตุลาคม';
    monthThai['11'] = 'พฤศจิกายน';
    monthThai['12'] = 'ธันวาคม';
    if (date) {
        // const convertDate = date.slice(0, 10);
        const newdate = dayjs(date).format('D') + " " + monthThai[dayjs(date).format('MM')] + " " + (parseInt(dayjs(date).format('YYYY')) + 543).toString() + " " + dayjs(date).format('HH:mm')
        return newdate
    }
}

export const getTimeFromMins = mins => {
    // do not include the first validation check if you want, for example,
    // getTimeFromMins(1530) to equal getTimeFromMins(90) (i.e. mins rollover)
    if (mins >= 24 * 60 || mins < 0) {
        throw new RangeError("Valid input should be greater than or equal to 0 and less than 1440.");
    }
    var h = mins / 60 | 0,
        m = mins % 60 | 0;
    if (m === 0) {
        return moment.utc().hours(h).minutes(m).format("h") + ' ชั่วโมง';
    } else {
        return moment.utc().hours(h).minutes(m).format("h:m") + ' ชั่วโมง';
    }
}

export const changeFormatdateThai = date => {
    let monthThai = [];
    monthThai['01'] = 'มกราคม';
    monthThai['02'] = 'กุมภาพันธ์';
    monthThai['03'] = 'มีนาคม';
    monthThai['04'] = 'เมษายน';
    monthThai['05'] = 'พฤษภาคม';
    monthThai['06'] = 'มิถุนายน';
    monthThai['07'] = 'กรกฎาคม';
    monthThai['08'] = 'สิงหาคม';
    monthThai['09'] = 'กันยายน';
    monthThai['10'] = 'ตุลาคม';
    monthThai['11'] = 'พฤศจิกายน';
    monthThai['12'] = 'ธันวาคม';
    if (date) {
        // const convertDate = date.slice(0, 10);
        const newdate = dayjs(date).format('D') + " " + monthThai[dayjs(date).format('MM')] + " " + (parseInt(dayjs(date).format('YYYY'))).toString()
        return newdate
    }
}

export const calculateAge = (birthDate) => {
    const today = new Date();
    const birthDateObj = new Date(birthDate);
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDiff = today.getMonth() - birthDateObj.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
        age--;
    }
    return age;
}